export const BUTTONS = {
  START_SETUP: 'StartSetup',
  HP_LOGO: 'HpLogo',
  WATCH_VIDEO: 'WatchVideo',
  CLOSE_VIDEO: 'CloseVideo',
  CLOSE_NOT_LISTED: 'CloseNotListed',
  ACCOUNT_CHOICE: 'AccountChoice',
  LEARN_MORE: 'LearnMore',
  CLOSE_LEARN_MORE: 'CloseLearnMore',
  CLOSE_SETUP_MODE: 'CloseSetupMode',
  SETUP_USB: 'SetupUsb',
  CLOSE_USE_OFFLINE: 'CloseUseOffline',
  INSTALL_HP_APP: 'InstallHpApp',
  INSTALL_HP_SMART: 'InstallHpSmart',
  INSTALL_HP_EASY_START: 'InstallHpEasyStart',
  AVAILABLE_SCANNING_FEATURES: 'AvailableScanningFeatures',
  VISIT_HP_SUPPORT: 'VisitHpSupport',
  INSTALL_DRIVERS: 'InstallDrivers',
  DOWNLOAD_DRIVERS: 'DownloadDrivers',
  TROUBLES_INSTALLING: 'TroublesInstalling',
  CLOSE_MODAL: 'CloseModal',
  CLOSE: 'Close',
  CLOSE_TROUBLE_INSTALLING: 'CloseTroubleInstalling',
  CLOSE_SCANNING_FEATURES_NOTICE: 'CloseScanningFeaturesNotice',
  VIEW_ANIMATIONS: 'ViewAnimations',
  USE_USB: 'UseUsb',
  HP_SUPPORT: 'HpSupport',
  LANGUAGE_SELECTOR: 'LanguageSelector',
  SELECT_LANGUAGE: 'SelectLanguage',
  CLOSE_LANGUAGE_SELECTOR: 'CloseLanguageSelector',
  CLOSE_SWITCH_TO_MOBILE: 'CloseSwitchToAmobileDevice',
  ALIGNMENT_REDIRECT_TO_GET_HELP: 'AlignmentRedirectToGetHelp',
  INSTALL_HP_SOFTWARE: 'InstallHpSoftware'
}

export const LINKS = {
  GO_123_HP: 'GoLinkHp123',
  WHERE_IS_PRODUCT_NAME: 'WhereIsProductName',
  DEVICE_NOT_LISTED: 'DeviceNotListed',
  CONTACT_HP_SUPPORT: 'ContactHPSupport',
  CHECK_SETUP_MODE: 'CheckSetupMode',
  VIEW_INSTRUCTIONS: 'ViewInstructions',
  VIEW_THESE_INSTRUCTIONS: 'ViewTheseInstructions',
  HP_SUPPORT: 'HpSupport',
  PRINTER_SUPPORT_SITE: 'PrinterSupportSite',
  FULL_USER_GUIDE: 'FullUserGuide',
  TROUBLE_INSTALLING: 'TroubleInstalling',
  HP_PLUS: 'HpPlus',
  INSTANT_INK: 'InstantInk',
  TROUBLESHOOTING_AND_GUIDES: 'TroubleshootingGuides',
  GET_HELP: 'GetHelp'
}
